import React from 'react'

function SearchNotification({cssClass = '', message, children}) {
  return (
    <div
      className={`search__message ${cssClass}`}
    >
      {children}
      {message}
    </div>
  )
}

export default SearchNotification